<template>
    <div class="col-md-12">
        <seccion-datos :titulo="interpwgs" :botonGuardar="false" class="card card-warning">
            <div class="row">
                <div class="col-md-8">
                    <div class="form-group">
                        <label>Compañía</label>
                        <select class="form-control" :disabled="!permisomodif" v-model="companyiaseleccionada">
                            <option selected value="">Todas</option>
                            <option v-for="companyia in companyias" :value="companyia.id" :key="companyia.id"> {{ companyia.nombre }} </option>
                        </select>
                    </div>
                </div>
                
            </div>
             <div class="row">
            <div class="col-md-10">
                <div class="form-group">
                    <label>Código</label>
                    <input :disabled="!permisomodif" type="text" v-model="codigo" class="form-control">
                    <br>
                    <button :disabled="!permisomodif" @click="anyadirCodigo()" class="btn btn-primary" >{{ $t('general.anadir') }}</button>
                </div>
            </div>
         

        </div>
             <div class="row">
                        <div class="col-md-12">
                            <table class="table table-sm table-striped">
                                <tbody v-if="codigosoperario && codigosoperario.length > 0">
                                    <tr v-for="codoper in codigosoperario" :value="codoper.id" :key="codoper.id" >
                                        <td ><!--companyias_id_companyia	-->
                                            <strong>{{ nombreCompania(codoper.companyias_id_companyia) }}</strong><br>
                                            {{codoper.codigo_interpwgs	}}
                                        </td>
                                        <td align="right">
                                            <div class="col-md-6">
                                                <button style="width:100px;height:100%" type="button" class="btn btn-block btn-outline-danger btn-xs" @click="eliminarInterpwgs(codoper.id)">{{ $t('general.eliminar') }}</button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                               
                            </table>
                        </div>
                    </div>
        </seccion-datos>
    </div>
</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi';
export default {
    props: ['id', 'operario', 'permisomodif'],
    data() {
        return {
            interpwgs: 'InterPWGS',
            companyias: [],
           companyiaseleccionada:'',
           codigo: '',
           codigosoperario:''
        }
    },
    watch: {
        operario() {
            
        },
    },
    methods: {
       async cargarCompanias(){
             //GET  modulos/pwgsapi/index.php/companias
            const api = new PwgsApi();
            let aux = await api.get('companias/simple,servicios?sortField=nombre&sortOrder=1');
            this.companyias = aux.datos;
        },
        async eliminarInterpwgs(idinterpwgs){
            const api = new PwgsApi();
            try {
                await api.delete('operarios/' +this.$props.id+'/codigos-interpwgs/'+idinterpwgs);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Código eliminado correctamente', life: 2000 });
                this.cargarCodigos();

            } catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        },
        nombreCompania(idCompania) {
    const comp = this.companyias.find(
      c => c.idcompañia == idCompania
    )
    return comp ? comp.nombre + ' (' + comp.prefijo + ')' : ''
  },
        async anyadirCodigo(){
            const api = new PwgsApi();
            let subidadatos = {id_compania: this.companyiaseleccionada, codigo: this.codigo};
            try{
                await api.post('operarios/' +this.$props.id+'/codigos-interpwgs',subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Código guardado correctamente', life: 2000 });
            }
            catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }

        },
        async cargarCodigos(){
            const api = new PwgsApi();
            let aux = await api.get('operarios/' +this.$props.id+'/codigos-interpwgs');
            this.codigosoperario = aux.datos;
        }
             
    },
    mounted() {
        this.cargarCompanias();
        this.cargarCodigos();
    },
    }
</script>

